import app from 'flarum/forum/app';
import FormModal from 'flarum/common/components/FormModal';
import Form from 'flarum/common/components/Form';
import Button from 'flarum/common/components/Button';
import Select from 'flarum/common/components/Select';
import Stream from 'flarum/common/utils/Stream';
import { loadStatuses, usableStatuses } from '../utils/statuses';
export default class ChangeStatusModal extends FormModal {
  ready = false;
  oninit(vnode) {
    super.oninit(vnode);
    const current = this.attrs.discussion.nhStatus?.();
    this.value = Stream(current ? String(current.id()) : '');
    loadStatuses().then(() => {
      this.ready = true;
      m.redraw();
    });
  }
  className() {
    return 'ChangeStatusModal Modal--small';
  }
  title() {
    return app.translator.trans('neverhack-forum-nodes.forum.status.modal_title');
  }
  content() {
    const options = {
      '': String(app.translator.trans('neverhack-forum-nodes.lib.status.none'))
    };
    usableStatuses().forEach(s => options[String(s.id())] = s.name());
    return m("div", {
      className: "Modal-body"
    }, m(Form, null, m("div", {
      className: "Form-group"
    }, m("label", null, app.translator.trans('neverhack-forum-nodes.lib.status.label')), m(Select, {
      options: options,
      value: this.value(),
      onchange: this.value,
      disabled: !this.ready
    })), m("div", {
      className: "Form-group Form-controls"
    }, m(Button, {
      type: "submit",
      className: "Button Button--primary",
      loading: this.loading
    }, app.translator.trans('neverhack-forum-nodes.lib.save')))));
  }
  onsubmit(e) {
    e.preventDefault();
    this.loading = true;
    const discussion = this.attrs.discussion;
    const id = this.value();
    const status = id ? app.store.getById('nh-statuses', id) : null;

    // Flarum's Model.save() drops `null` relationships, so send the PATCH ourselves
    // to be able to clear the status as well.
    app.request({
      method: 'PATCH',
      url: `${app.forum.attribute('apiUrl')}/discussions/${discussion.id()}`,
      body: {
        data: {
          type: 'discussions',
          id: discussion.id(),
          relationships: {
            nhStatus: {
              data: status ? {
                type: 'nh-statuses',
                id: status.id()
              } : null
            }
          }
        }
      }
    }).then(payload => {
      app.store.pushPayload(payload);
      this.hide();
      m.redraw();
    }).catch(err => {
      this.loading = false;
      this.onerror(err);
    });
  }
}
flarum.reg.add('neverhack-forum-nodes', 'forum/components/ChangeStatusModal', ChangeStatusModal);